<template>
  <v-container>
    <h4>Supplier list</h4>
    <v-row
        v-for="(item, i) in supplier_list"
        :key="i"
      >
        <v-col
          cols="1"
        >
          {{ i+1 }}
        </v-col>
        <v-col
          cols="11"
        >
          {{ item.name }}
          <br/>
          <small>Branch: {{ item.branch }}</small>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SupplierList',
  components: { },
  props: ['supplier_list'],
  data: () => ({ }),
  methods: { }
}
</script>